import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorServerModalComponent } from '@banyan/modules/standalone/error-server-modal/error-server-modal.component';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class ErrorServerInterceptor implements HttpInterceptor {
  serverErrors: number[] = [
    500, 501, 502, 503, 504, 505, 506, 507, 508, 510, 511,
  ];
  constructor(private readonly dialog: MatDialog) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.serverErrors.includes(error.status) && !error.url?.includes('/api/need-capture/notes/suggestions')) {
          this.dialog.open(ErrorServerModalComponent);
        }
        return throwError(() => error);
      })
    );
  }
}
